import { Component, Input } from '@angular/core';

@Component({
  selector: 'europool-loadingbar',
  template: `
    <div class="loading-progress-bar" *ngIf="loading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  `,
})
export class LoadingbarComponent {
  @Input() loading: boolean = false;
}
